import {
  ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_FAILURE,
  ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_REQUEST,
  ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_SUCCESS,
  FETCH_CALIX_NETWORKS_CUSTOMER_LIST_FAILURE,
  FETCH_CALIX_NETWORKS_CUSTOMER_LIST_REQUEST,
  FETCH_CALIX_NETWORKS_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { CalixNetworksCustomers } from "./types";

export const fetchCalixNetworksCustomerListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  },
) => ({
  type: FETCH_CALIX_NETWORKS_CUSTOMER_LIST_REQUEST,
  url,
  payload,
});

export const fetchCalixNetworksCustomerListSuccess = (
  calixNetworksCustomerList: CalixNetworksCustomers[],
  totalCount: number,
) => ({
  type: FETCH_CALIX_NETWORKS_CUSTOMER_LIST_SUCCESS,
  payload: { calixNetworksCustomerList, totalCount },
});

export const fetchCalixNetworksCustomerListFailure = (error: string) => ({
  type: FETCH_CALIX_NETWORKS_CUSTOMER_LIST_FAILURE,
  payload: error,
});

export const addUpdateCalixNetworksCustomerRequest = (
  url: string,
  payload: CalixNetworksCustomers,
  callback: (type: string, message: string) => void,
) => ({
  type: ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCalixNetworksCustomerSuccess = (
  successMessage: string,
) => ({
  type: ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_SUCCESS,
  payload: { successMessage },
});

export const addUpdateCalixNetworksCustomerFailure = (error: string) => ({
  type: ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_FAILURE,
  payload: error,
});
